import { GeocodedData } from '../../../../../../../../submodules/web-shared/api/locations-api/types/GeocodedData';

export const optionsModifier = (mapboxOptions: GeocodedData[]) => {
  return mapboxOptions.map(option => {
    const latitude = Number(option.lat.toFixed(6));
    const longitude = Number(option.lng.toFixed(6));

    return {
      id: option.place_name,
      label: option.place_name,
      latitude,
      longitude,
      ...option.address
    };
  });
};
